import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Upgrade() {
  return (
    <section className="upgrade_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>Ready To Upgrade Your Business?</h2>
            <p>So Are We! </p>
            <p>
              We know how to take apps above and beyond to deliver results and
              achieve business goals.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-lg-2 text-center resp_order"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/hde/Tek_img_05.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={602}
                height={663}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Upgrade;
